import React, { useState } from 'react';
import { realisations } from '../data/mockData';
import { ExternalLink } from 'lucide-react';

const Realisations = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  
  const categories = ['Tous', ...new Set(realisations.map(r => r.category))];
  
  const filteredRealisations = selectedCategory === 'Tous' 
    ? realisations 
    : realisations.filter(r => r.category === selectedCategory);

  return (
    <section id="realisations" className="py-20 bg-gradient-to-b from-[#F5EFE6]/30 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#F5EFE6] rounded-full mb-4">
            <span className="text-[#8B7355] font-semibold text-sm">Nos Réalisations</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Quelques-unes de nos réalisations
          </h2>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-[#8B7355] text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-[#F5EFE6] border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {filteredRealisations.map((realisation, index) => (
            <div
              key={realisation.id}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                  src={realisation.image}
                  alt={realisation.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block px-3 py-1 bg-[#8B7355] text-white text-xs font-semibold rounded-full mb-3">
                    {realisation.category}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {realisation.title}
                  </h3>
                  <div className="flex items-center text-white/90 text-sm">
                    <span>Voir le projet</span>
                    <ExternalLink className="w-4 h-4 ml-2" />
                  </div>
                </div>
              </div>

              {/* Category Badge (visible by default) */}
              <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                <span className="text-[#8B7355] text-xs font-semibold">
                  {realisation.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 text-lg mb-6">
            Un projet en tête ?
          </p>
          <a 
            href="tel:0650088282"
            className="inline-block bg-[#8B7355] hover:bg-[#6B5744] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
          >
            Contactez-nous : 06 50 08 82 82
          </a>
        </div>
      </div>
    </section>
  );
};

export default Realisations;
